import { styled, useMediaQuery, useTheme } from "@mui/material";
import React, { memo, useCallback, useState } from "react";
import {
  axiosInstanceContratos,
  axiosInstanceMain,
} from "../../utils/axiosGlobalUtils";
import SnackBarUtils from "../../utils/SnackBarUtils";
import { ContractComponentProps } from "./ContractList";
import ContractMobile from "./ContractMobile";
import ContractDesktop from "./ContractDesktop";
import {
  msjAyerAntes,
  msjAyerAntesPremium,
  msjHoyMañanaPremium,
  msjMañana,
} from "./msj-whpp";



export interface SingleContractProps extends ContractComponentProps {
  loadingAccion: boolean;
  loadingMP: boolean;
  handleLinkMP: (id: number) => void;
  executeAction: (action: any, id: number) => void;
  handleWhpp: () => string;
  getDateDifference: (date: string) => number;
}

const ContractComponent: React.FC<ContractComponentProps> = ({
  contracts,
  contract,
  index,
  group,
  noShow,
  noShowContracts,
  setNoShowContracts,
  requestSort,
  sortConfig,
  setShowRenovations,
  setRenewContract,
}: ContractComponentProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [loadingMP, setLoadingMP] = useState<boolean>(false);
  const [loadingAccion, setLoadingAccion] = useState<boolean>(false);

  const getDateDifference = () => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const endDate = new Date(
      parseInt(contract.fechaFinFormateada.split("/")[2]),
      parseInt(contract.fechaFinFormateada.split("/")[1]) - 1,
      parseInt(contract.fechaFinFormateada.split("/")[0])
    );
    const differenceInMilliseconds = currentDate.getTime() - endDate.getTime();

    // Convertir la diferencia a días
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);

    // Devolver la diferencia en días
    return differenceInDays;
  };

  const getMsj = () => {
    if (
      group.includes("Vencidos") &&
      contract.productoTipoNombre === "Premium"
    ) {
      return msjAyerAntesPremium;
    } else if (
      group.includes("VencenHoy") &&
      contract.productoTipoNombre === "Premium"
    ) {
      return msjHoyMañanaPremium;
    } else if (group.includes("Vencidos")) {
      return msjAyerAntes;
    } else if (group.includes("Vencen")) {
      return msjMañana;
    }
  };

  const handleDate = () => {
    switch (group) {
      case "VencenHoy":
        return "Hoy";
      case "VencenMañana":
        return "Mañana";
      case "VencidosAyer":
        return "Ayer";
      case "VencidosAntes":
        return `Hace ${getDateDifference()} días`;
      default:
        return "";
    }
  };
  const handleWhppButton = () => {
    let msj = getMsj();
    const cuando = handleDate();
    msj = msj?.replace("{{nombre producto}}", contract.productoNombre);
    msj = msj?.replace("{{precio}}", contract.precioLista.toString());
    msj = msj?.replace("{{link}}", contract.linkDePago);
    msj = msj?.replace("{{cuando}}", cuando);

    return `https://api.whatsapp.com/send?phone=${contract.clienteWhatsapp}&text=${encodeURI(
      msj || ""
    )}`;
  };
  
  const handleLinkMP = async (idContrato: number) => {
    try {
      setLoadingMP(true);
      axiosInstanceContratos
        .get(`/contratos/generateLinkPayment?idContract=${idContrato}`)
        .then((res) => {
          navigator.clipboard.writeText(res.data);
          SnackBarUtils.success("Link copiado");
        });
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingMP(false);
    }
  };

  const executeAction = useCallback(
    (action: any, idContrato: number) => {
      const url = action.url;
      setLoadingAccion(true);
      axiosInstanceMain
        .get(url)
        .then((result) => {
          result.status === 200
            ? SnackBarUtils.success(result.data)
            : SnackBarUtils.error(result.data);
          if (result.status === 200) {
            setNoShowContracts([...noShowContracts, idContrato]);
          }
        })
        .catch((error) => {
          console.log(error);
          SnackBarUtils.error(error.response.data);
        })
        .finally(() => {
          setLoadingAccion(false);
        });
    },
    [noShowContracts, isMobile]
  );

  return (
    <>
      {isMobile ? (
        <ContractMobile
          contracts={contracts}
          contract={contract}
          index={index}
          group={group}
          loadingAccion={loadingAccion}
          loadingMP={loadingMP}
          noShow={noShow}
          noShowContracts={noShowContracts}
          setNoShowContracts={setNoShowContracts}
          requestSort={requestSort}
          sortConfig={sortConfig}
          setShowRenovations={setShowRenovations}
          setRenewContract={setRenewContract}
          handleLinkMP={handleLinkMP}
          executeAction={executeAction}
          handleWhpp={handleWhppButton}
          getDateDifference={getDateDifference}
        />
      ) : (
        <ContractDesktop
          contracts={contracts}
          contract={contract}
          index={index}
          group={group}
          loadingAccion={loadingAccion}
          loadingMP={loadingMP}
          noShow={noShow}
          noShowContracts={noShowContracts}
          setNoShowContracts={setNoShowContracts}
          requestSort={requestSort}
          sortConfig={sortConfig}
          setShowRenovations={setShowRenovations}
          setRenewContract={setRenewContract}
          handleLinkMP={handleLinkMP}
          executeAction={executeAction}
          handleWhpp={handleWhppButton}
          getDateDifference={getDateDifference}
        />
      )}
    </>
  );
};

export default memo(ContractComponent);
